module.exports = "/_next/static/images/slide2-1cf31c41722ca298862dbadd8bc7d95e.jpg.webp";